import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function PasskeyIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M5 20q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 18v-.8q0-.85.438-1.562.437-.713 1.162-1.088a14.8 14.8 0 0 1 3.15-1.163A13.8 13.8 0 0 1 11 13q.35 0 .7.012.35.014.7.063a.63.63 0 0 1 .438.213q.162.187.162.462.05 1.174.575 2.213.525 1.037 1.4 1.762a.9.9 0 0 1 .275.313q.1.187.1.412V19q0 .424-.287.712a.97.97 0 0 1-.713.288zm6-8q-1.65 0-2.825-1.175T7 8t1.175-2.825T11 4t2.825 1.175T15 8t-1.175 2.825T11 12m7.5 2q.424 0 .712-.287A.97.97 0 0 0 19.5 13a.97.97 0 0 0-.288-.713A.97.97 0 0 0 18.5 12a.97.97 0 0 0-.712.287.97.97 0 0 0-.288.713q0 .424.288.713.287.287.712.287m.15 8.65-1-1q-.05-.05-.15-.35v-4.45a3.45 3.45 0 0 1-1.8-1.238Q15 14.7 15 13.5q0-1.45 1.025-2.475A3.37 3.37 0 0 1 18.5 10q1.45 0 2.475 1.025A3.37 3.37 0 0 1 22 13.5a3.3 3.3 0 0 1-.637 2q-.638.875-1.613 1.25l.9.9a.48.48 0 0 1 0 .7l-.8.8a.48.48 0 0 0 0 .7l.8.8a.48.48 0 0 1 0 .7l-1.3 1.3a.48.48 0 0 1-.7 0" />
    </Icon>
  );
}

PasskeyIcon.displayName = 'PasskeyIcon';
